import React, { useState, useCallback, useContext } from 'react';
import styled from 'styled-components';
import { Modal, FlexColumn, TextArea } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import useAccount from '@ubeya/shared/hooks/account/useAccount';

const Container = styled(FlexColumn)`
  margin: 25px;
`;

const BlockEmployeeModal = ({ data, onClose, handleBlockEmployee }) => {
  const { t } = useContext(ConfigContext);
  const { account } = useAccount();

  const [employeeBlockReason, setEmployeeBlockReason] = useState(null);

  const onBlock = useCallback(async () => {
    const comment = t('employeeBlockedFromClientComment', {
      clientName: account?.name,
      comment: employeeBlockReason
    });

    await handleBlockEmployee({ ...data, blockingReasonComment: comment, blockingReason: employeeBlockReason });
    onClose();
  }, [account?.name, data, employeeBlockReason, handleBlockEmployee, onClose, t]);

  return (
    <>
      <Modal
        onConfirm={onBlock}
        usePortal
        size="small"
        onClose={onClose}
        title={t('blockReason')}
        showConfirmButton
        showCancelButton
        disabledConfirm={!employeeBlockReason}
        confirmText={t('ok')}
        isPaddingContent={false}
        isScrollableContent={false}>
        <Container>
          <TextArea
            value={employeeBlockReason}
            onChange={setEmployeeBlockReason}
            placeholder={t('addComment')}
            minRows={3}
            maxLength={500}
          />
        </Container>
      </Modal>
    </>
  );
};

export default BlockEmployeeModal;
